import { makeStyles } from '@fluentui/react-components';
import { ThemeSelector } from '../../theme/ThemeSelector';

export const Header = () => {
  const styles = useStyles();

  return (
    <header className={styles.header}>
      <a href="https://www.groovnow.com/">
        <img src={'/logo.png'} alt="Groov" className={styles.logo} />
      </a>
      <ThemeSelector />
    </header>
  );
};

const useStyles = makeStyles({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '60px',
  },
  logo: {
    height: '60px',
  },
});
